import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getStatusLabel = (status) => {
  const labels = {
    pending: "Pending",
    assigned: "Assigned",
    in_progress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    open: "Open",
    investigating: "Investigating",
    resolved: "Resolved",
    active: "Active",
    inactive: "Inactive",
    invited: "Invited",
    available: "Available",
    in_use: "In Use",
    maintenance: "Maintenance",
    mock: "Mock",
    queued: "Queued",
    sent: "Sent",
    failed: "Failed",
  };
  return labels[status] || status?.replace(/_/g, " ") || "-";
};

export const getStatusTone = (status) => {
  const tones = {
    pending: "bg-slate-100 text-slate-700 border-slate-200",
    assigned: "bg-amber-50 text-amber-700 border-amber-200",
    in_progress: "bg-blue-50 text-blue-700 border-blue-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    cancelled: "bg-rose-50 text-rose-700 border-rose-200",
    open: "bg-rose-50 text-rose-700 border-rose-200",
    investigating: "bg-amber-50 text-amber-700 border-amber-200",
    resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
    active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    inactive: "bg-slate-100 text-slate-700 border-slate-200",
    invited: "bg-violet-50 text-violet-700 border-violet-200",
    available: "bg-emerald-50 text-emerald-700 border-emerald-200",
    in_use: "bg-blue-50 text-blue-700 border-blue-200",
    maintenance: "bg-amber-50 text-amber-700 border-amber-200",
    mock: "bg-slate-100 text-slate-700 border-slate-200",
    queued: "bg-blue-50 text-blue-700 border-blue-200",
    sent: "bg-emerald-50 text-emerald-700 border-emerald-200",
    failed: "bg-rose-50 text-rose-700 border-rose-200",
  };
  return tones[status] || "bg-slate-100 text-slate-700 border-slate-200";
};

export const getRoleLabel = (role) => {
  const labels = {
    admin: "Admin",
    driver: "Driver",
    school: "School",
    parent: "Parent",
  };
  return labels[role] || role;
};

export const initials = (name = "CF") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "CF";

export const copyToClipboard = async (value) => {
  if (!value) return false;
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch (error) {
    return false;
  }
};
